import { useNavigate } from 'react-router-dom';
import { CaretRightIcon } from '@phosphor-icons/react';

export default function TestCard({ test, packId }) {
  const navigate = useNavigate();
  const getAbbreviation = (title) => {
    if (title.includes('QPT')) return 'QPT';
    if (title.includes('QFT')) return 'QFT';
    if (title.includes('PYQ')) return 'PYQ';
    if (title.includes('2025')) return '2025';
    if (title.includes('2024')) return '2024';
    if (title.includes('2023')) return '2023';
    return title
      .split(' ')
      .slice(0, 3)
      .map((word) => word[0])
      .join('')
      .toUpperCase();
  };

  const handleCardClick = () => {
    if (packId !== '676e96bfe0722dfa6ce1d7ed') {
      navigate(`/v3/${packId}/tests?categoryId=${test.title}`);
    }
  };

  const abbreviation = test.abbreviation || getAbbreviation(test.title);
  const count = test.count || test.testsCount;
  const title = test.title;
  const description = test.description || `Test series with ${count} tests`;

  return (
    <div
      className={`relative rounded-xl h-[120px] w-full shadow-none bg-[var(--q3-surface-dim)] flex flex-col justify-between p-3 pl-5 cursor-pointer hover:bg-[var(--q3-surface-dimmer)] hover:border hover:border-1 transition-all duration-300`}
      onClick={handleCardClick}
    >
      {/* Icon at top-right */}
      <CaretRightIcon size={16} className="absolute top-4 right-4 text-[var(--q3-accent-normal)]" weight="bold" />

      {/* Content */}
      <div className="flex flex-col gap-2">
        <div className="flex flex-row text-xs">
          <p className="text-xl font-bold pt-1 leading-none">{title}</p>
        </div>
        <span className="text-[var(--q3-neutral-light)] text-xs">{count} Tests</span>
      </div>

      <p className="text-xs font-light text-[var(--q3-neutral-light)]">{description}</p>
    </div>
  );
}
